// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"e2711219","243":"adb4289f","413":"6977d1a8","461":"1eb3384b","949":"ca8eb3f5","998":"77a41a40"}[chunkId] + ".chunk.js";
};